function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#fff;}.cls-5{font-size:20.3px;fill:#df4f70;font-family:Barlow-Medium, Barlow;font-weight:500;}.cls-6{letter-spacing:-0.03em;}.cls-7{letter-spacing:0em;}.cls-8{letter-spacing:-0.04em;}.cls-9{letter-spacing:0em;}.cls-10{letter-spacing:0em;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 21.57,
  y1: 4.87,
  x2: 79.86,
  y2: 56.23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#772fea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#732ee9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#682de7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#562ae3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3d26de"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 128.91,
  y1: 31.86,
  x2: 16.09,
  y2: 86.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#772fea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#7c30e5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#9a3ac1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#b341a3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#c7478d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#d44c7d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#dc4e73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#df4f70"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 74.33,
  y1: 101.15,
  x2: 74.33,
  y2: -14.62,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#df4f70"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#e78460"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#eba058"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Asset 1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M84.31,19.17V81.32a3.5,3.5,0,0,1-5.5,2.89L10.93,36.44a3.51,3.51,0,0,1,0-5.73L36.86,13.47a3.46,3.46,0,0,1,4,.08l10.27,7.3a3,3,0,0,1-.17,4.84l-8.91,6a2.31,2.31,0,0,0,0,3.79L64.38,51.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M64.34,29.61V91.34a3.49,3.49,0,0,0,5.5,2.85l69.44-46.25a3.49,3.49,0,0,0,0-5.71l-26-18.29a3.15,3.15,0,0,0-3.76.1L98.17,31.66a3,3,0,0,0,.18,4.83l8.78,6.11a2.31,2.31,0,0,1,0,3.79L84.32,61.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M79.77,84.88,66,75.2a4.4,4.4,0,0,1-1.67-3.82V2.88A2.87,2.87,0,0,1,68.89.55L80.81,8.94a7.52,7.52,0,0,1,3.51,6.74v67.2C84.32,85.22,81.67,86.25,79.77,84.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M14.32,144.17,0,106.15H12.56L20.74,133,29,106.15H41.12l-14.32,38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M45.49,144.17v-38H57.62v38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M105.72,144.17H93.52v-5a13.76,13.76,0,0,1-11.43,5.51c-10.72,0-17.77-7.9-17.77-19.68s7-19.33,17.49-19.33a14.1,14.1,0,0,1,11.71,5.5V91.84h12.2Zm-12.2-18.9c0-5.86-3.39-9.88-8.47-9.88s-8.46,4-8.53,9.88,3.45,9.94,8.53,9.94S93.52,131.12,93.52,125.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M156.14,125.34c0,11.57-6.91,19.26-17.56,19.26a14.07,14.07,0,0,1-11.64-5.51v5.08h-12.2V91.84h12.2v19.32a13.87,13.87,0,0,1,11.36-5.43C149,105.73,156.14,113.56,156.14,125.34ZM143.87,125c0-5.79-3.46-9.88-8.53-9.88s-8.4,4.09-8.4,9.88,3.46,9.94,8.4,9.94S143.87,130.84,143.87,125Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M196.34,119.34v24.83H184.42V139.8c-2.47,3.24-6.49,4.94-11.64,4.94-8.11,0-13.05-4.94-13.05-11.92,0-7.2,5.15-11.43,14.6-11.5h10v-.56c0-3.74-2.47-6-7.41-6a26.79,26.79,0,0,0-11.35,3.17l-3.46-8c5.92-2.75,11.29-4.3,17.63-4.3C190.2,105.59,196.27,110.74,196.34,119.34Zm-12,11.93v-3.39h-7.69c-3.67,0-5.5,1.27-5.5,4.09s2,4.51,5.36,4.51C180.33,136.48,183.57,134.37,184.35,131.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M228.36,106.15h13.33l-12.07,18.48,12.91,19.54h-14l-6.92-11.92-7.75,11.92H200.42l13-19.47-12.13-18.55h14l6.34,10.94Z"
}), /*#__PURE__*/React.createElement("text", {
  className: "cls-5",
  transform: "translate(63.45 167.57)"
}, "ea", /*#__PURE__*/React.createElement("tspan", {
  className: "cls-6",
  x: 21.42,
  y: 0
}, "s"), /*#__PURE__*/React.createElement("tspan", {
  className: "cls-7",
  x: 30.68,
  y: 0
}, "y video "), /*#__PURE__*/React.createElement("tspan", {
  className: "cls-8",
  x: 96.82,
  y: 0
}, "f"), /*#__PURE__*/React.createElement("tspan", {
  className: "cls-9",
  x: 103.44,
  y: 0
}, "ee"), /*#__PURE__*/React.createElement("tspan", {
  className: "cls-10",
  x: 125.28,
  y: 0
}, "d"), /*#__PURE__*/React.createElement("tspan", {
  x: 136.41,
  y: 0
}, "back"))));

var SvgLogoFull = function SvgLogoFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 242.53 172.05",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-full.45583428.svg";
export { ForwardRef as ReactComponent };